import React from 'react';

import StaticPageLayout from './StaticPageLayout';

const Careers = () => (
  <StaticPageLayout
    eyebrow='Join the team'
    title='Careers at Evento'
    intro="We're building Sri Lanka's home for event professionals — and we're looking for people who love great events and even better products."
    sections={[
      {
        heading: 'Why work with us',
        paragraphs: [
          'Evento connects event planners with trusted photographers, decorators, caterers, DJs and more across the island. Behind that simple idea is a small, ambitious team shipping quickly and caring deeply about the experience for both clients and professionals.',
          'We value ownership, curiosity and kindness. You will work directly with the people making decisions, see the impact of your work fast, and grow with the company.',
        ],
      },
      {
        heading: 'What we look for',
        bullets: [
          'A bias for action and a willingness to learn in the open',
          'Care for craft — whether that is code, design, operations or support',
          'Empathy for our users: the couple planning a wedding and the professional growing a business',
          'Clear, honest communication',
        ],
      },
      {
        heading: 'Open positions',
        paragraphs: [
          'We hire across engineering, design, operations, partnerships and customer support. We are always happy to hear from exceptional people even when a matching role is not listed.',
        ],
        bullets: [
          'Full-stack Engineer (React / Node)',
          'Product Designer',
          'Partnerships & Category Manager',
          'Customer Support Specialist',
        ],
      },
      {
        heading: 'How to apply',
        paragraphs: [
          'Send your CV and a short note about what you would like to work on to careers@evento.lk. Tell us about something you have built or improved — we care more about that than a perfect résumé.',
        ],
      },
    ]}
  />
);

export default Careers;
